var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#0088CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3702 7.00011C17.4702 6.99811 17.6912 7.02311 17.8352 7.14011C17.9308 7.2232 17.9919 7.33918 18.0062 7.46511C18.0222 7.55811 18.0422 7.77111 18.0262 7.93711C17.8462 9.83511 17.0642 14.4391 16.6662 16.5641C16.4982 17.4641 16.1672 17.7651 15.8462 17.7941C15.1502 17.8591 14.6212 17.3341 13.9462 16.8921C12.8902 16.1991 12.2932 15.7681 11.2682 15.0921C10.0832 14.3121 10.8512 13.8821 11.5262 13.1821C11.7032 12.9981 14.7732 10.2051 14.8332 9.95211C14.8402 9.92011 14.8472 9.80211 14.7772 9.74011C14.7072 9.67811 14.6032 9.69911 14.5282 9.71611C14.4222 9.74011 12.7352 10.8561 9.46716 13.0611C8.98716 13.3911 8.55416 13.5511 8.16516 13.5411C7.73716 13.5331 6.91316 13.3001 6.30016 13.1011C5.54816 12.8561 4.95116 12.7271 5.00316 12.3121C5.03016 12.0961 5.32816 11.8751 5.89616 11.6491C9.39416 10.1251 11.7262 9.12011 12.8942 8.63511C16.2262 7.24911 16.9192 7.00811 17.3702 7.00011Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.7bc8c1b3356f70dcf5303c414336b50b.svg";
export { ForwardRef as ReactComponent };